module.exports = __webpack_public_path__ + "img/icon11@2x.9826435e.png";